import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { MdFilterListAlt, MdRemoveRedEye } from "react-icons/md";
import { DepositRequestListsByDate } from "../../Server/api";
import {
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight
} from "react-icons/md";
const DepositReportdateWiseList = () => {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState("");
  const [selectedEndDate, setSelectedEndDate] = useState("");
  const limit =50
  const [fillter, setFillter] = useState(false);
  const [filters, setFilters] = useState({
    from_date: "",
    to_date: "",
    limit: 10,
  });
  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const navigate = useNavigate();
  const token = localStorage.getItem("token") || "";
  useEffect(() => {
    fetchReport();
  }, [currentPage, filters]);

  // ✅ new
  const handleFilter = () => {
    setCurrentPage(1);

 setFilters((prev) => ({
  ...prev,
  from_date: selectedStartDate,
  to_date: selectedEndDate,
}));
  };

 const handlePrevPage = () => {
  if (currentPage > 1) {
    setCurrentPage((prev) => prev - 1);
  }
};

const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage((prev) => prev + 1);
  }
};

const handlePageClick = (pageNo) => {
  setCurrentPage(pageNo);
};

  const fillterdata = () => {
    setFillter((prev) => !prev);
  };
  const handleReset = () => {
    setSelectedStartDate("");
    setSelectedEndDate("");

    setCurrentPage(1);

    setFilters({
      from_date: "",
      to_date: "",
       limit: 10,
    });

    setFillter(false);
  };
  const fetchReport = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        from_date: filters.from_date,
        to_date: filters.to_date,
        limit:filters.limit
      };
      const result = await DepositRequestListsByDate(params);
      if (result.data.success) {
        setData(result.data.data || []);
        setTotalPages(result.data.pagination?.totalPages || 1);
        setTotalRecords(result.data.pagination?.total || 0);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching withdraw summary:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
const getPageNumbers = () => {
  const pageNumbers = [];
  const maxVisiblePages = 3;

  let startPage = Math.max(1, currentPage - 1);

  let endPage = Math.min(
    totalPages,
    startPage + maxVisiblePages - 1
  );

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(
      1,
      endPage - maxVisiblePages + 1
    );
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  return pageNumbers;
};
  return (
    <div className="mt-3">
      <div className="card">
        <div className="card-header bg-color-black">
          <div className="d-flex align-items-center justify-content-between">
            <h3 className="card-title text-white">
              Datewise Deposite List
            </h3>
            <div className="">
              <div className="fillterbutton" onClick={fillterdata}>
                <MdFilterListAlt /> Filter
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
             {fillter && (
            <div className="row mb-3">
              <div className="col-md-12 d-flex gap-2 align-items-end">
               <div className="w-100">
                  <label>Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedStartDate}
                    onChange={(e) => setSelectedStartDate(e.target.value)}
                  />
                </div>

                <div className="w-100">
                  <label>End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={selectedEndDate}
                    onChange={(e) => setSelectedEndDate(e.target.value)}
                  />
                </div>

                <button className="btn btn-primary" onClick={handleFilter}>
                  Apply
                </button>

                <button className="btn btn-outline-secondary" onClick={handleReset}>
                  Reset
                </button>

              </div>
            </div>
          )}

          {loading ? (
            <p>Loading...</p>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Date</th>
                      <th>Total Amount</th>
                      <th>Total Count</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={index}>
                          <td>{(currentPage - 1) * 10 + index + 1}</td>
                          <td>{item.date}</td>
                          <td>₹ {item.totalAmount}</td>
                          <td>{item.totalCount}</td>
                          {/* <td>
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            navigate(
                              `/deposit_detail/${item.date}`
                            )
                          }
                        >
                          View
                        </button>
                      </td> */}
                          <td className="text-center">
                            <MdRemoveRedEye
                              size={22}
                              className=""
                              title="View Details"
                              onClick={() => navigate(`/date_wise_deposit_detail/${item.date}`)}
                            />
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* ✅ Pagination Controls */}
              {/* {data.length > 0 && totalPages > 0 && (
                <ul className="d-flex justify-content-between align-items-center mt-3">
                  <li
                    className="paginationbutton btn btn-secondary"
                    disabled={currentPage === 1}
                    onClick={handlePrev}
                  >
                    <span>Previous</span>
                  </li>
                  <span className="alllistnumber">
                    Page {currentPage} of {totalPages}
                  </span>
                  <li
                    className="paginationbutton btn btn-secondary"
                    disabled={currentPage === totalPages}
                    onClick={handleNext}
                  >
                    <span>Next</span>
                  </li>
                </ul>
              )} */}


              {data.length > 0 && totalPages > 0 && (
  <div className="d-flex justify-content-between align-items-center mt-4">

    {/* LEFT SIDE */}
    <div className="sohwingallentries">
      Showing{" "}
      {(currentPage - 1) * limit + 1}

      {" "}to{" "}

      {Math.min(currentPage * limit, totalRecords)}

      {" "}of{" "}

      {totalRecords} entries
    </div>

    {/* RIGHT SIDE */}
    <div className="paginationall d-flex align-items-center gap-2">

      {/* PREV */}
      <button
        className="d-flex justify-content-center align-items-center"
        disabled={currentPage === 1}
        onClick={handlePrevPage}
      >
        <MdOutlineKeyboardArrowLeft />
      </button>

      {/* PAGE BUTTONS */}
      <div className="d-flex gap-1">
        {getPageNumbers().map((pageNo) => (
          <button
            key={pageNo}
            className={`paginationnumber ${
              pageNo === currentPage
                ? "active"
                : ""
            }`}
            onClick={() => handlePageClick(pageNo)}
          >
            {pageNo}
          </button>
        ))}
      </div>

      {/* NEXT */}
      <button
        className="d-flex justify-content-center align-items-center"
        disabled={currentPage === totalPages}
        onClick={handleNextPage}
      >
        <MdOutlineKeyboardArrowRight />
      </button>

    </div>
  </div>
)}
            </>
          )}
        </div>
      </div>
      {/* 🔍 Date Filters */}
    </div>
  );
};

export default DepositReportdateWiseList;
